import React, { useEffect } from "react";
import AppBody from "../components/AppBody";
import { useSelector, useDispatch } from "react-redux";
import { getDashboardData } from "../../actions/learning_provider/dashborad_action";
import { Link } from "react-router-dom";
import online from "../../images/landingPage/online.svg";
import { UI_URL } from "../../config/api";
const LearningProviderDashboard = () => {
  const state = useSelector((state) => state.dashboardReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    let redirect = localStorage.getItem("meetingRedirect");
    if (redirect) {
      localStorage.removeItem("meetingRedirect");
      window.close();
    }
    if (localStorage.getItem("token")) dispatch(getDashboardData());
  }, []);

  const joinTrainigClick = (slug) => {
    window.open(UI_URL + "/conference/" + slug);
    let workingTraining = localStorage.getItem("workingTraining");
    let trCount = localStorage.getItem("trCount");
    if (!trCount && !workingTraining) {
      localStorage.setItem("trCount", 1);
      window.open(UI_URL + "/conference/" + slug);
    }
  };
  const statCard = [0];
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left lrn-provider">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="dash-heading">Upcomming Trainings</h1>
            </div>
            {state.list &&
              state.list.map((li, i) => (
                <div className="col-lg-4 mt-3" key={i + 1}>
                  <div className="card bg-theme-color shadow-lg">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-7">
                          <h4 className="fw-700 font-xss my-1">
                            <Link
                              to={"/training/" + li.slug}
                              className="text-grey-900"
                            >
                              {li.name}{" "}
                            </Link>
                          </h4>
                        </div>
                        <div className="col-5 pl-0">
                          <button
                            className="btn-common"
                            onClick={() => joinTrainigClick(li.slug)}
                          >
                            Join Training
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body p-2">
                      <div className="row">
                        <div className="col-12">
                          <span>
                            <strong>Start Date :</strong>
                          </span>
                          <span> {li.start_date}</span>
                          <br />
                          <span>
                            <strong>End Date :</strong>
                          </span>
                          <span> {li.end_date}</span>
                        </div>
                      </div>

                      <div className="row my-1">
                        <div className="col-12">
                          <div className="paths-list-details">
                            {/* <ul>
                                <li>
                                  <span className="ti-video-camera paths-icon" alt="Number of Courses">
                                  </span>
                                  <span>18 Trainigs</span></li>
                                <li>
                                  <span className="ti-time paths-icon" alt="Duration"></span>
                                  <span>65 hours</span></li>                               
                             </ul>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            {/* <div>
              <div className="box">
                <div className="row">
                  <div className="col-xs-12 col-8">
                    <h4 className="title">
                      <span className="course-nm">CSS</span>
                    </h4>
                  </div>
                  <div className="col-xs-12 col-4">
                    <img className="" src={online} alt="First slide" />
                  </div>
                  <div className="col-12">
                    <a href="#." className="banner-btn posts-btn btn-common">
                      Enroll
                    </a>
                  </div>
                </div>
              </div>
          </div>*/}
          </div>
        </div>
      }
    />
  );
};

export default LearningProviderDashboard;
